import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCustomersTransactionLogsQuery } from '../store/services/customers';

const ProblemExchangeTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    customersProblemTransactions: {
      exchange: { logs },
    },
    customersDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const [getExcahngeLogs, { isLoading }] =
    useLazyGetCustomersTransactionLogsQuery();

  const getExchangeLogsAction = useCallback(() => {
    getExcahngeLogs(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!logs && transactionId) {
      getExchangeLogsAction();
    }
  }, [getExchangeLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoading}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_EXCHANGE_LIST,
      )}
    />
  );
};

export default ProblemExchangeTransactionLogContentHOC;
